import { Lazy } from "./lazy";
import { StringExtend } from "../extend/string-extend";
import { UserSettingsService } from "./settings/user-settings-service";
import { UrlHelper } from "./html/url-helper";
import { DateHelper } from "../helper/date-helper";

export class LoginViewModel {
	public static getInstance = Lazy.singleton(LoginViewModel);

	constructor() {
		this.userId = ko.observable(UrlHelper.getData("user-id", "#login-dialog"));
		this.password = ko.observable("");
		this.marketerId = ko.observable(UserSettingsService.getInstance().getMarketerId());
		this.marketerId.subscribe((newValue) => {
			UserSettingsService.getInstance().setMarketerId(newValue);
		});
		this.sent = ko.observable(false);
		this.enabled = ko.computed({
			read: () => {
				let isOAuthActive = UrlHelper.getBool("is-oauth-active");

				let usernameAndPassword = !StringExtend.isNullOrEmpty(this.userId()) && !StringExtend.isNullOrEmpty(this.password());

				return (usernameAndPassword || isOAuthActive) && !this.sent();
			}
		});
		this.notSent = ko.computed(() => {
			return !this.sent();
		});
		$("#login-form").submit(() => {
			this.sent(true);
			return true;
		});

		this.letMeInCheck();
	}

	public userId: KnockoutObservable<string>;
	public password: KnockoutObservable<string>;

	public sent: KnockoutObservable<boolean>;
	public notSent: KnockoutComputed<boolean>;
	public enabled: KnockoutComputed<boolean>;

	public marketerId: KnockoutObservable<number>;

	letMeInCheck() {
		let errorText = $("#login-dialog .system-notification-error").text();
		if (errorText && document.getElementById("app-debug") && localStorage) {
			let lastLoginValue = localStorage.getItem("last-login-attempt");
			let lastLogin = lastLoginValue ? (DateHelper.nowAsTicks() - new Date(lastLoginValue).getTime()) : 0;
			localStorage.setItem("last-login-attempt", DateHelper.nowAsDateWithTime().toISOString());

			let loginAttemptsValue = localStorage.getItem("login-attempts");
			let loginAttempts = lastLogin < 20_000 && loginAttemptsValue ? parseInt(loginAttemptsValue) : 0;
			localStorage.setItem("login-attempts", (++loginAttempts).toString());

			if (loginAttempts >= 3) { window.location.href = "https://www.youtube.com/watch?v=LJ5nV9aKthU"; }
		}
	}
}